import React from "react";
import cn from "classnames";

export interface ButtonGroupProps extends React.HtmlHTMLAttributes<HTMLDivElement> {}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({ className, ...props }) => {
  return <div className={cn(className, "button-group")} {...props} />;
};
